module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Regular TH.888855d6.eot";